import { useEffect } from 'react';
import { userManager } from '../config';
import { createSessionRenewal } from '../utils/sessionRenewal';

/**
 * Håller sessionen vid liv efter access-tokenets livstid (~5 min i Keycloak).
 * Själva logiken ligger i utils/sessionRenewal.ts – se kommentaren där för
 * varför förnyelsen måste ske i exakt ett flöde åt gången.
 */
export const AuthLifecycle = () => {
  useEffect(() => {
    const renewal = createSessionRenewal(userManager, {
      currentUrl: () => window.location.href,
    });
    renewal.start();
    return () => renewal.stop();
  }, []);

  return null;
};
